export default "__VITE_ASSET__3fdfoGPg__"